export type TextareaOverflowY = 'auto' | 'hidden';

export interface TextareaFit {
    heightPx: number;
    overflowY: TextareaOverflowY;
}

// Grows with the text up to the cap; past it the textarea scrolls itself.
export function textareaFit(scrollHeightPx: number, maxHeightPx: number): TextareaFit {
    return {
        heightPx: Math.min(scrollHeightPx, maxHeightPx),
        overflowY: scrollHeightPx > maxHeightPx ? 'auto' : 'hidden'
    };
}
